import React, { useRef, useState } from 'react'

import { isEmpty } from 'lodash'

import { Box, Flex, Header, Icon, Text } from '@driftt/dds'
import { faChevronDown } from '@driftt/dds.icons/light/faChevronDown'
import { faChevronUp } from '@driftt/dds.icons/light/faChevronUp'
import { faCircleInfo } from '@driftt/dds.icons/light/faCircleInfo'

import Card from 'components/Card'
import ExplainContents, { EngagementScoreOverview } from 'components/Explain'
import TooltipHoverPortal from 'components/TooltipHoverPortal'
import { AccountActivity } from 'modules/accountActivity/domain'

import styles from './styles.module.css'

interface Props {
  explainData: AccountActivity
}

const TooltipBody = () => (
  <Flex
    css={{
      background: '$white',
      padding: '$1',
      borderTop: '$lime3 4px solid',
      width: '150px',
      borderRadius: '$1',
      boxShadow: '$1'
    }}>
    <Text variant="body">Based on activity from the past 2 weeks</Text>
  </Flex>
)

const EngagementScoreSection = (props: Props) => {
  const { explainData } = props
  const scoredActivity = explainData.accountScoredActivity
  const [isOpen, setIsOpen] = useState(true)
  const infoContainerRef = useRef<HTMLDivElement>(null)
  const iconContainerRef = useRef<HTMLDivElement>(null)

  return (
    <Card>
      <Flex
        css={{
          fontFamily: '$bodyBold',
          textTransform: 'uppercase'
        }}
        justifyContent="space-between"
        alignItems="center"
        ref={infoContainerRef}>
        <Flex alignItems="center">
          <Header variant="h4">Engagement Score</Header>

          {!isEmpty(scoredActivity?.topActivities) && (
            <Box ref={iconContainerRef} css={{ cursor: 'pointer', flex: 'none' }}>
              <TooltipHoverPortal
                placement="top"
                offset={[0, 15]}
                tooltipBody={<TooltipBody />}
                refElement={iconContainerRef?.current}
                boundaryRef={infoContainerRef?.current}>
                <Icon icon={faCircleInfo} width="15px" />
              </TooltipHoverPortal>
            </Box>
          )}
        </Flex>
        <div className={styles.collapseIcon} onClick={() => setIsOpen(!isOpen)}>
          <Icon icon={isOpen ? faChevronDown : faChevronUp} width="12px" />
        </div>
      </Flex>
      {isOpen && (
        <Box
          css={{
            marginTop: '$2'
          }}>
          <EngagementScoreOverview
            radial
            className={styles.marginNone}
            score={explainData.normalizedEngagementScore}
          />
          {!isEmpty(scoredActivity?.topActivities) ? (
            <Box>
              <ExplainContents
                includeOverview={false}
                includeHeader={false}
                accountActivity={explainData}
                truncate={false}
              />
            </Box>
          ) : (
            <Box>
              <Text css={{ textAlign: 'center' }} variant="body">
                This account has not engaged with enough activity to impact the engagement score.
              </Text>
            </Box>
          )}
        </Box>
      )}
    </Card>
  )
}

export default EngagementScoreSection
